
export class FMRequestHazardMaterial {
  registerHazardMaterialId: number;
  chemicalName: string;
  fmTypeofActivityId: number;
  fmTypeofActivityName: string;
  size: number;
  amount: number;
  amountInStock: number;
  unitsId: number;
  unitsName: string;



 
}




// WEBPACK FOOTER //
// ./src/app/core/models/fm-request-hazard-material.ts